export async function sendContactForm(payload) {
  try {
    const res = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    let data = null;
    try {
      data = await res.json();
    } catch {
      data = null;
    }

    if (!res.ok || !data?.ok) {
      return {
        ok: false,
        error: data?.error || "Could not send your message. Please try again.",
      };
    }

    return { ok: true };
  } catch (err) {
    return {
      ok: false,
      error: "Network error. Check your connection and try again.",
    };
  }
}
